module.exports = __webpack_public_path__ + "img/green-carpet-grass-07.bbc1269d.png";